import React, { Component } from 'react';
import CustomInput from '../Components/CustomInput';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { setToken, logOutApp } from '../../GlobalModules/Login/Actions/LoginAction';
import { loaderStateTrue, loaderStateFalse } from '../../Actions/AllAction';
import * as UtilityController from '../Controller/UtilityController';
import Utility from '../Utility'


class ChangePasswordContent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userEmail: "",
			password: "",
			newPassword: "",
			confirmPassword: "",
			userEmailError: "",
			passwordError: "",
			newPasswordError: "",
			confirmPasswordError: "",
			//Change force password modal password show hide
			changePasswordLock: false,
			changeConfirmPasswordLock: false,
			currentPasswordLock: false,
			changePassType: "password",
			changeConfirmPassType: "password",
			currentPassType: "password",
		}
	}

	handleChangeUserData = (event, type) => {
		/*if (type == "userEmail") {
			if (event != "") {
				this.setState({
					userEmail: event.target.value,
					userEmailError: "",
				})
			} else {
				this.setState({
					userEmail: event.target.value,
					userEmailError: "Required field"
				})
			}
		}*/
		if (type == "password") {
			if (event != "") {
				this.setState({
					password: event.target.value,
					passwordError: "",
				})
			} else {
				this.setState({
					password: event.target.value,
					passwordError: "Required field"
				})
			}
		}
		if (type == "newPassword") {
			if (event != "") {
				this.setState({
					newPassword: event.target.value,
					newPasswordError: "",
				})
			} else {
				this.setState({
					newPassword: event.target.value,
					newPasswordError: "Required field"
				})
			}
		}
		if (type == "confirmPassword") {
			if (event != "") {
				this.setState({
					confirmPassword: event.target.value,
					confirmPasswordError: "",
				})
			} else {
				this.setState({
					confirmPassword: event.target.value,
					confirmPasswordError: "Required field"
				})
			}
		}
		this.setState({
		})
	}

	validchangePasswordForm = () => {
		const { t } = this.props;
		let valid = true;

		// if (this.state.userEmail == "") {
		// 	valid = false;
		// 	this.setState({
		// 		userEmailError: this.props.t('invalidField')
		// 	})
		// }
		if (this.state.password.trim() == "") {
			valid = false;
			this.setState({
				passwordError: this.props.t('invalidField')
			})
		}
		if (this.state.newPassword.trim() == "") {
			valid = false;
			this.setState({
				newPasswordError: this.props.t('invalidField')
			})
		}
		if (this.state.confirmPassword.trim() == "") {
			valid = false;
			this.setState({
				confirmPasswordError: this.props.t('invalidField')
			})
		}

		if (this.state.newPassword.trim() != "" && this.state.confirmPassword.trim() != "") {

			/* let passwordValidate = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-+“!@#%&/,><\’:;|_~`])\S{6,99}$/.test(this.state.newPassword);

			if (passwordValidate) {
				this.setState({
					newPasswordError: ''
				})
			} else {
				valid = false;
				this.setState({
					newPasswordError: t('thisFieldIsInvalid')
				})
				Utility.toastNotifications(`<ul className='password-inner-box'>
				<li><b>${t('minimumLength')}</b>, ${t('mustBeAtLeast6Characters')}</li>
				<li><b>${t('requireNumbers')}</b></li>
				<li><b>${t('requireSpecialCharacter')}</b> ${t('fromThisSet')}: = + - ^ $ * . [ ] { } ( ) ?  ! @ # % & / \ , > < ' : ; | _ ~ </li>
				<li><b>${t('requireUppercaseLetters')}</b></li>
				<li><b>${t('requireLowercaseLetters')}</b></li>
				</ul>`, `${t('passworderror')}`, "longError");
			}


			let CpasswordValidate = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-+“!@#%&/,><\’:;|_~`])\S{6,99}$/.test(this.state.confirmPassword);

			if (CpasswordValidate) {
				this.setState({
					confirmPasswordError: ''
				})
			} else {
				valid = false;
				this.setState({
					confirmPasswordError: t('thisFieldIsInvalid')
				})
				Utility.toastNotifications(`<ul className='password-inner-box'>
				<li><b>${t('minimumLength')}</b>, ${t('mustBeAtLeast6Characters')}</li>
				<li><b>${t('requireNumbers')}</b></li>
				<li><b>${t('requireSpecialCharacter')}</b> ${t('fromThisSet')}: = + - ^ $ * . [ ] { } ( ) ?  ! @ # % & / \ , > < ' : ; | _ ~ </li>
				<li><b>${t('requireUppercaseLetters')}</b></li>
				<li><b>${t('requireLowercaseLetters')}</b></li>
				</ul>`, `${t('confirmPasswordError')}`, "longError");
			} */

			if (this.state.newPassword.trim() == this.state.confirmPassword.trim()  && this.state.newPassword.trim()  != "" && this.state.confirmPassword.trim()  != "") {
				this.setState({
					newPasswordError: '',
					confirmPasswordError: ''
				})
			} else {
				valid = false;
				Utility.toastNotifications(t('passwordAndConfirmPasswordNotMatch'), "Error", "error");
			}
		}



		return valid;
	}

	changePasswordfromSubmitData = () => {
		let valid = this.validchangePasswordForm();
		if (valid) {
			const { loaderStateTrue, loaderStateFalse } = this.props;
			let data = {

				"pre_password": this.state.password.trim(),

				"new_password": this.state.newPassword.trim()

			};
			//return false;
			loaderStateTrue();
			UtilityController.userNewPasswordChange(data).then((response) => {
				loaderStateFalse();
				if (response.success) {
					Utility.toastNotifications(response.message, "Success", "success");
					this.props.closeChangePassword();
				}

			}).catch((error) => {
				console.error("************error*************", error)
				if (error) {
					//Utility.toastNotifications(error.message, "Error", "error");
				}
				loaderStateFalse();
				if (error.message == "Network Error") {
					/*Utility.toastNotifications("Please login", "Error", "error");
					this.props.logOutApp().then(
						() => this.props.history.push("/")
					);*/
				}
			});
		}
	}

	//Change force password modal password show hide
	changeShowText = () => {
		this.setState({
			changePasswordLock: true,
			changePassType: "text"
		})
	}

	changeShowPassword = () => {
		this.setState({
			changePasswordLock: false,
			changePassType: "password"
		})
	}
	changeConfirmShowText = () => {
		this.setState({
			changeConfirmPasswordLock: true,
			changeConfirmPassType: "text"
		})
	}

	changeConfirmShowPassword = () => {
		this.setState({
			changeConfirmPasswordLock: false,
			changeConfirmPassType: "password"
		})
	}
	currentConfirmShowText = () => {
		this.setState({
			currentPasswordLock: true,
			currentPassType: "text"
		})
	}

	currentConfirmShowPassword = () => {
		this.setState({
			currentPasswordLock: false,
			currentPassType: "password"
		})
	}

	render() {
		const { t, closeChangePassword, userCredentials } = this.props;
		let user_email = "";
		if (userCredentials && userCredentials.user_details && userCredentials.user_details.user_email != "") {
			user_email = userCredentials.user_details.user_email
		}

		if (user_email == "" && userCredentials && userCredentials.user_details && userCredentials.user_details.contact_number != "") {
			user_email = userCredentials.user_details.contact_number
		}
		return (
			<>
				<div className="modalinnerbody">
					<div className="change_password_row_body">
						<div className="change_password_row">
							<CustomInput
								parentClassName="comment_input_field"
								//errorLabel={this.state.userEmailError}
								name="userEmail"
								type="text"
								value={user_email}
								//labelPresent={true}
								onChange={(e) => this.handleChangeUserData(e, "userEmail")}
								//placeholder={t('emailIdPlaceHolder')}
								readOnly={true}
							/>
						</div>
						<div className="change_password_row changePassRow">
							<CustomInput
								parentClassName="comment_input_field"
								errorLabel={this.state.passwordError}
								name="password"
								type={`${this.state.currentPassType == 'text' ? 'text' : 'password'}`}
								value={this.state.password}
								//labelPresent={true}
								onChange={(e) => this.handleChangeUserData(e, "password")}
								placeholder={t('enterCurrentPassword')}
							//readOnly={true}
							/>
							{!this.state.currentPasswordLock ?
								<span className="passwordEyeIcon" onClick={this.currentConfirmShowText}><i className="fa fa-eye-slash" aria-hidden="true"></i></span>
								:
								<span className="passwordEyeIcon" onClick={this.currentConfirmShowPassword}><i className="fa fa-eye" aria-hidden="true"></i></span>
							}
						</div>
						<div className="change_password_row">
							<div className="input-field-full-box changePassRow">
								<CustomInput
									parentClassName="comment_input_field"
									errorLabel={this.state.newPasswordError}
									name="newPassword"
									type={`${this.state.changePassType == 'text' ? 'text' : 'password'}`}
									value={this.state.newPassword}
									//labelPresent={true}
									onChange={(e) => this.handleChangeUserData(e, "newPassword")}
									placeholder={t('enterNewPassword')}
								//readOnly={true}
								/>
								{!this.state.changePasswordLock ?
									<span className="passwordEyeIcon" onClick={this.changeShowText}><i className="fa fa-eye-slash" aria-hidden="true"></i></span>
									:
									<span className="passwordEyeIcon" onClick={this.changeShowPassword}><i className="fa fa-eye" aria-hidden="true"></i></span>
								}
							</div>
						</div>
						<div className="change_password_row">
							<div className="input-field-full-box changePassRow">
								<CustomInput
									parentClassName="comment_input_field"
									errorLabel={this.state.confirmPasswordError}
									name="confirmPassword"
									type={`${this.state.changeConfirmPassType == 'text' ? 'text' : 'password'}`}
									value={this.state.confirmPassword}
									//labelPresent={true}
									onChange={(e) => this.handleChangeUserData(e, "confirmPassword")}
									placeholder={t('reEnterPassword')}
								//readOnly={true}
								/>
								{!this.state.changeConfirmPasswordLock ?
									<span className="passwordEyeIcon" onClick={this.changeConfirmShowText}><i className="fa fa-eye-slash" aria-hidden="true"></i></span>
									:
									<span className="passwordEyeIcon" onClick={this.changeConfirmShowPassword}><i className="fa fa-eye" aria-hidden="true"></i></span>
								}
							</div>
						</div>
					</div>
					<div className="col-md-12 modfooterbtn">
						<button type="button" className="savebtn" onClick={this.changePasswordfromSubmitData}>{t('submit')}</button>
						<button type="button" className="cancelbtn" onClick={this.props.closeChangePassword}>{t('cancel')}</button>
					</div>
				</div>
			</>
		);
	}
}

ChangePasswordContent.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func,
	className: PropTypes.string,
	headerclassName: PropTypes.string,
	bodyClassName: PropTypes.string,
	headerContent: PropTypes.string,
	formData: PropTypes.object,
	errorData: PropTypes.object,
	handleChange: PropTypes.func,
	submit: PropTypes.func
}

ChangePasswordContent.defaultProps = {
	className: "change_password_modal",
	headerclassName: "close_btn_icon",
	buttonClassName: "btn btn-primary",
	headerContent: "Change Password",
	BodyContent: "",
	buttonContent: "",
	bodyClassName: ""
}

const mapStateToProps = (globalState) => {
	return {
		userCredentials: globalState.LoginReducer.userCredentials
	};
}


export default withRouter(connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setToken })
	(withTranslation()(ChangePasswordContent)));